import { useState, useEffect } from 'react';
import { analyticsApi } from '../../api/client';
import { Icon } from '../../components/Icon';

const MEDAL_COLORS: Record<number, string> = { 1: '#f59e0b', 2: '#9ca3af', 3: '#b45309' };

export function RankingPage() {
  const [entries, setEntries] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const myCode = localStorage.getItem('emp_code') || '';

  useEffect(() => {
    analyticsApi.getLeaderboard(50)
      .then(data => { setEntries(data.items || []); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  if (loading) return <div className="loading-state"><span className="spinner" /></div>;

  const myEntry = entries.find(e => e.employeeCode === myCode);

  function formatDate(s: string): string {
    if (!s) return '';
    try {
      const d = new Date(s);
      const now = Date.now();
      const diff = now - d.getTime();
      if (diff < 60000) return '刚刚';
      if (diff < 3600000) return `${Math.floor(diff / 60000)}分钟前`;
      if (diff < 86400000) return `${Math.floor(diff / 3600000)}小时前`;
      return `${d.getMonth() + 1}月${d.getDate()}日`;
    } catch {
      return s;
    }
  }

  return (
    <div className="page">
      <h1>企业排名</h1>
      <p style={{ color: 'var(--gray-500)', marginBottom: 12, fontSize: 13 }}>
        按套题平均正确率排序
      </p>

      {myEntry && (
        <div className="my-rank-card">
          <div className="my-rank-label">我的排名</div>
          <div className="my-rank-num">#{myEntry.rank}</div>
          <div className="my-rank-rate">{(myEntry.avgRate * 100).toFixed(1)}%</div>
        </div>
      )}

      {entries.length === 0 ? (
        <div className="empty-state">
          <div className="empty-state-icon"><Icon name="trophy" size={48} color="var(--gray-300)" /></div>
          <p className="empty-state-text">暂无排名数据，完成答题后上榜</p>
        </div>
      ) : (
        <div className="ranking-list">
          {entries.map((entry) => {
            const isTop3 = entry.rank <= 3;
            return (
              <div
                key={entry.rank}
                className={`ranking-item ${isTop3 ? 'top' + entry.rank : ''} ${entry.employeeCode === myCode ? 'is-me' : ''}`}
              >
                <div className="ranking-rank">
                  {isTop3 ? (
                    <Icon name="medal" size={24} color={MEDAL_COLORS[entry.rank]} filled />
                  ) : (
                    <span>{entry.rank}</span>
                  )}
                </div>
                <div className="ranking-info">
                  <div className="ranking-code">
                    {entry.employeeCode}
                    {entry.employeeCode === myCode && <span className="me-badge">我</span>}
                  </div>
                  <div className="ranking-time">完成于 {formatDate(entry.completedAt)}</div>
                </div>
                <div className="ranking-rate">{(entry.avgRate * 100).toFixed(1)}%</div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
